import React              from "react";
import TextField          from "@mui/material/TextField";

function CustomTextFieldModifica({
  name,
  label,
  type,
  onChange,
  values,
  initialValues,
  disabled,
  maxLength,
}) {

  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  return (
    <TextField
      name={name}
      label={label}
      type={type}
      variant="outlined"
      fullWidth
      inputProps={{
        maxLength: maxLength,
      }}
      value={String(values[name] || initialValues[name] || "").replace(/_/g, ' ')}
      onChange={handleChange}
      disabled={disabled}
      sx={{
        width: "100%",
        textAlign: "left",
        borderRadius: "10px",
        backgroundColor: "#FFFFFF", 
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#fda03d",
          },
          ...(!disabled && {
            "&:hover fieldset": {
              borderColor: "#fda03d", 
            },
          }),
          "&.Mui-focused fieldset": {
            borderColor: "#fda03d", 
          },
        },
        "& .MuiOutlinedInput-root.Mui-disabled": {
          bgcolor: "transparent",
          cursor: "not-allowed",
        },
        "& .Mui-disabled": {
          cursor: "not-allowed",
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#fda03d", 
        },
      }}
    />
  );
}

export default CustomTextFieldModifica;
